import router from './router';
import store from './store';
import {
	getLoginKey
} from '@/utils/auth'

const whiteList = ['/login', '/entry', '/proResearch', '/finish'];


router.beforeEach((to, from, next) => {
	if (getLoginKey()) {
		if (store.getters.roles.length === 0) { // 判断当前用户是否拥有路由权限
			store.dispatch('user/GetUserInof').then(res => {
				const roles = [res.data.roleId];
				store.dispatch('permission/generateRoutes', roles).then(() => {
					router.addRoutes(store.getters.addRouters);
					next({
						...to
					});
				});
			})
		} else {
			next();
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) { // 免登录白名单，直接进入
			next();
		} else {
			const {
				query
			} = to;
			next({
				path: '/login',
				query
			});
		}
	}
});

router.afterEach((to) => {
	document.title = to.meta.title || '智伍互联';
})
